import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';

// RxJS
import { Observable } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';

// Services
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
    constructor(private auth: AuthService, private router: Router) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.auth.user$.pipe(
            take(1),
            tap(user => {
                if(!user?.admin) {
                    this.router.navigate([''], { queryParams: { returnUrl: state.url }});
                }
            }),
            map(user => !!user)
            );
    }
  
}
